import React, {useState} from 'react';

import PropTypes from 'prop-types';

import styles from './styles.scss';

const propTypes = {
  href: PropTypes.string.isRequired,
};

export const SkipToContent = (props) => {
  const {skipToContent, focused} = styles;
  const [isFocused, setIsFocused] = useState(false);


  return (
    <a
      href={props.href}
      aria-label="Skip To Content"
      className={`${skipToContent} ${isFocused && focused}`}
      data-qa-selector="skip_to_content"
      onBlur={() => {
        setTimeout(() => {
          setIsFocused(false);
        }, 500);
      }}
      onFocus={() => setIsFocused(true)}
    >
      Skip To Content
    </a>
  );
};


SkipToContent.propTypes = propTypes;
export default SkipToContent;
